import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';

export default function LoadingState({ title, description, compact = false, timed = false }) {
    const [seconds, setSeconds] = useState(0);
    useEffect(() => {
        if (!timed) return undefined;
        const started = Date.now();
        const timer = setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 1000);
        return () => clearInterval(timer);
    }, [timed]);
    return <div className={`rgnet-loading-state${compact ? ' rgnet-loading-compact' : ''}`} role="status" aria-live="polite">
        <span aria-hidden="true"><Spin size={compact ? 'small' : 'default'} /></span>
        <div><strong>{title}</strong>{description && <p>{description}</p>}
            {timed && <span className="rgnet-loading-time" aria-live="off">已等待 {seconds} 秒 · 可切换手动模式继续查询</span>}</div>
    </div>;
}
